module Meevo.Plugins.Egifts {
    'use strict';

    import IStorageFile = Meevo.Model.IStorageFile;

    export interface ISectionParamsEgifts {
        sectionId: number;
        displayNameContentKey: string;
        template: string;
        isPrimarySection: boolean;
        handlesOwnCrud: boolean;
        baseEndpoint: string;
        sectionEndpoint: string;
        loggingService: Meevo.Components.Logging.ILoggingService;
        dataService: Meevo.Components.CommonClasses.ICommonDataService;
        context: EgiftsContext;
        egiftsService: Meevo.Plugins.Egifts.EgiftsService;
        identityService: Components.Common.IIdentityService;
        busyService: Meevo.Components.Busy.IBusyService;
        noun: Meevo.Model.NounEnum;
        sectionSecurityKey?: string;
        $q?: angular.IQService;
    }

    export class EgiftsBaseSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        protected egiftsService: Meevo.Plugins.Egifts.EgiftsService;
        protected context: EgiftsContext;
        protected busyService: Meevo.Components.Busy.IBusyService;
        protected identityService: Meevo.Components.Common.IIdentityService;
        protected $q: angular.IQService;
        protected dataService: Meevo.Components.CommonClasses.ICommonDataService;

        constructor(params: ISectionParamsEgifts) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.noun,
                params.identityService,
                params.sectionSecurityKey);

            this.egiftsService = params.egiftsService;
            this.context = params.context;
            this.busyService = params.busyService;
            this.$q = params.$q;
            this.dataService = params.dataService;
            this.identityService = params.identityService;
        }

        public filterByAvailableInEgift: Array<IFilterByAvailableInEgift> = [
            {
                value: null,
                title: 'LABEL_SHOW_ALL'
            }, {
                value: true,
                title: 'LABEL_YES'
            }, {
                value: false,
                title: 'LABEL_NO'
            }
        ];

        getResults(url, onPageLoad?, requireCount = false) {
            return new Meevo.Components.BaseClasses.PagedResults(this.egiftsService.dataService, url, onPageLoad, this.context, null, null, requireCount);
        }
    }
}
